var React = require('react');

function App (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.695.556l-7.5-.008c-.825 0-1.5.675-1.5 1.5v13.5c0 .825.675 1.5 1.5 1.5h7.5c.825 0 1.5-.675 1.5-1.5v-13.5c0-.825-.675-1.492-1.5-1.492zm0 13.492h-7.5v-10.5h7.5v10.5z","fill":"currentColor","fillRule":"evenodd"}));
}

App.defaultProps = {"width":"12","height":"18","viewBox":"0 0 12 18"};

module.exports = App;

App.default = App;
